import React, { useState } from 'react';
import { FileTextIcon, PaperclipIcon } from 'lucide-react';
import { DocumentPreviewModal } from './DocumentPreviewModal';
import { conditionStatusTone, type Condition, type ConditionStatus } from '../data/loanData';
type ConditionsPanelProps = {
  conditions: Condition[];
};
function ConditionRow({
  condition
}: {
  condition: Condition;
}) {
  const [status, setStatus] = useState<ConditionStatus>(condition.status);
  const [previewOpen, setPreviewOpen] = useState(false);
  return <li className="flex flex-wrap items-center gap-3 px-5 py-3" data-id="element-87" data-mp="27p6oyl269zdf">
      <div className="min-w-0 flex-1" data-id="element-88" data-mp="27rsz8sgg6szc">
        <p className="text-[13px] font-medium text-ink" data-id="element-89" data-mp="22xoody42a0sz">{condition.name}</p>
        <p className="mt-0.5 text-[11.5px] uppercase tracking-wide text-gray-400" data-id="element-90" data-mp="1xzwuwznrq6mo">
          {condition.category}
        </p>
      </div>

      {condition.document ? <button type="button" onClick={() => setPreviewOpen(true)} className="inline-flex min-w-0 max-w-[240px] items-center gap-1.5 rounded-lg border border-gray-200 bg-white px-2.5 py-1.5 text-[12px] text-ink transition-colors hover:border-brand hover:text-brand" data-id="element-91" data-mp="2vh3yg5i5gfbd">
          <PaperclipIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-92" data-mp="15uxgggfcagwm" />
          <span className="truncate" data-id="element-93" data-mp="s1g014hy9kat">{condition.document}</span>
        </button> : <span className="inline-flex items-center gap-1.5 rounded-lg border border-dashed border-gray-200 px-2.5 py-1.5 text-[12px] text-gray-400" data-id="element-94" data-mp="wz7xee1d5yme">
          <FileTextIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-95" data-mp="n2d0u0oni8ar" />
          No document
        </span>}

      <span className={['w-[92px] shrink-0 rounded-full px-2.5 py-1 text-center text-[11px] font-medium', conditionStatusTone[status]].join(' ')} data-id="element-96" data-mp="93lsyw0dtiv2">
        {status}
      </span>

      <DocumentPreviewModal condition={previewOpen ? condition : null} onClose={() => setPreviewOpen(false)} onAccept={() => setStatus('Accepted')} onUnassociate={() => setStatus('Rejected')} data-id="element-97" data-mp="23i668nmdic4f" />
    </li>;
}
export function ConditionsPanel({
  conditions
}: ConditionsPanelProps) {
  const outstanding = conditions.filter(condition => condition.status === 'Outstanding').length;
  const withDocs = conditions.filter(condition => Boolean(condition.document)).length;
  return <section className="rounded-xl border border-gray-200 bg-white" data-id="element-98" data-mp="1s3mhdrv7ap2f">
      <header className="flex flex-wrap items-center gap-2 border-b border-gray-200 px-5 py-3.5" data-id="element-99" data-mp="2pnyz3hwoaf82">
        <h3 className="text-[14px] font-semibold text-ink" data-id="element-100" data-mp="2kri8mh203ort">
          Conditions ({conditions.length})
        </h3>
        <p className="text-[12px] text-gray-500" data-id="element-101" data-mp="2fxmg3u4iau41">
          {outstanding} outstanding · {withDocs} with documents
        </p>
      </header>
      <ul className="divide-y divide-gray-100" data-id="element-102" data-mp="38fi05j74zj7g">
        {conditions.map(condition => <ConditionRow key={condition.id} condition={condition} data-id="element-103" data-mp="33p1mpz3bfxl3" />)}
        {conditions.length === 0 && <li className="px-5 py-8 text-center text-[12.5px] text-gray-500" data-id="element-104" data-mp="3b0pown2kjaix">
            No conditions on this file yet.
          </li>}
      </ul>
    </section>;
}